<script lang="ts">
  import { onMount } from 'svelte';

  export let parent: HTMLElement | null = null;
  let portal: HTMLDivElement;

  onMount(() => {
    const p = parent ?? document.body;

    p.appendChild(portal);
    return () => {
      p?.removeChild(portal);
    };
  });
</script>

<div class="portal" bind:this={portal}>
  <slot />
</div>
